<template>
    <div>
        <div id="proposalTypeModal" data-backdrop="static" data-keyboard="false" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            {{ proposalTypeModalTitle }}
                        </h4>
                        <button type="button" dusk="modal-close-button" @click="proposalTypeCancel()"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-2">
                                <div class="form-group">
                                    <input  class="form-control"
                                            type="text"
                                            v-model="proposalTypeName"
                                            id="proposal_type_name">
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button v-if="proposalTypeModalButton == 'Save'" id="save-proposal-type" name="save-proposal-type"
                                @click="saveProposalType()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            {{ proposalTypeModalButton }}
                        </button>
                        <button v-if="proposalTypeModalButton == 'Update'" id="update-proposal-type" name="update-proposal-type"
                                @click="updateProposalType()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            {{ proposalTypeModalButton }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div id="assignTemplateGroup" data-backdrop="static" data-keyboard="false" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            Assign Proposal Template Group
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                @click="cancelAssignProposalTemplateGroup()"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-2">
                                <div class="form-group">
                                    <multiselect
                                        id="allProposalTemplateGroups"
                                        v-model="selectedProposalTemplateGroup"
                                        :options="allProposalTemplateGroups"
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="false"
                                        :taggable="false"
                                        open-direction="below"
                                        placeholder="Pick Proposal Section Content"
                                        :showLabels="false"
                                        label="name"
                                        track-by="id"
                                        :preselect-first="false"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button name="save-proposal-type"
                                @click="assignTemplateGroup()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div id="CoverPageSettingModal" data-backdrop="static" data-keyboard="false" class="modal fade" role="dialog" v-if="coverSection">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            Cover Page Options
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal"
                                @click="cancelCoverPageSettings()">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-2">
                                <div class="form-group">
                                    <h4 class="mb-4">Cover Page Options</h4>
                                    <div class="coverCheckboxDiv">
                                        <label for="checkbox-1" class="ml-auto mb-0 float-left">Turn Off Cover Page</label>
                                        <b-form-checkbox
                                            id="checkbox-1"
                                            v-model="tempCoverSectionSettings.allCover"
                                            name="checkbox-1"
                                            value=1
                                            unchecked-value=0
                                            @change="turnOffCover"
                                            class="float-right">
                                        </b-form-checkbox>
                                    </div>
                                    <div class="coverCheckboxDiv">
                                        <label for="checkbox-2" class="ml-auto mb-0 float-left">Cover Page 1</label>
                                        <b-form-checkbox
                                            id="checkbox-2"
                                            v-model="tempCoverSectionSettings.cover1"
                                            name="checkbox-2"
                                            value=1
                                            unchecked-value=0
                                            @change="turnOnOtherSections"
                                            class="float-right">
                                        </b-form-checkbox>
                                    </div>
                                    <div class="coverCheckboxDiv">
                                        <label for="checkbox-3" class="ml-auto mb-0 float-left">Cover Page 2</label>
                                        <b-form-checkbox
                                            id="checkbox-3"
                                            v-model="tempCoverSectionSettings.cover2"
                                            name="checkbox-3"
                                            value=1
                                            unchecked-value=0
                                            @change="turnOnOtherSections"
                                            class="float-right">
                                        </b-form-checkbox>
                                    </div>
                                    <div class="coverCheckboxDiv">
                                        <label for="checkbox-4" class="ml-auto mb-0 float-left">Cover Page 3</label>
                                        <b-form-checkbox
                                            id="checkbox-4"
                                            v-model="tempCoverSectionSettings.cover3"
                                            name="checkbox-4"
                                            value=1
                                            unchecked-value=0
                                            @change="turnOnOtherSections"
                                            class="float-right">
                                        </b-form-checkbox>
                                    </div>
                                    <div class="coverCheckboxDiv">
                                        <label for="checkbox-5" class="ml-auto mb-0 float-left">Cover Page 4</label>
                                        <b-form-checkbox
                                            id="checkbox-5"
                                            v-model="tempCoverSectionSettings.cover4"
                                            name="checkbox-5"
                                            value=1
                                            unchecked-value=0
                                            @change="turnOnOtherSections"
                                            class="float-right">
                                        </b-form-checkbox>
                                    </div>
                                    <div class="coverCheckboxDiv">
                                        <label for="checkbox-6" class="ml-auto mb-0 float-left">Cover Page 5</label>
                                        <b-form-checkbox
                                            id="checkbox-6"
                                            v-model="tempCoverSectionSettings.cover5"
                                            name="checkbox-6"
                                            value=1
                                            unchecked-value=0
                                            @change="turnOnOtherSections"
                                            class="float-right">
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button  id="cancel-cover-page-setting" name="cancel-cover-page-setting"
                                @click="cancelCoverPageSettings()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Cancel
                        </button>
                        <button id="save-cover-page-setting" name="save-cover-page-setting"
                                @click="saveCoverPageSettings()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <b-container>
            <b-row align-h="center">
                <b-col cols="12">
                    <b-card-group deck>
                        <b-card header="Proposal Settings" header-tag="header">
                            <b-container>
                                <b-row align-h="center">
                                    <b-col cols="12">
                                        <div>
                                            <div class="proposal-type-buttons">
                                                <div class="flex-1 text-left float-left">
                                                    <b-dropdown id="proposal-type-setting" dropright :text="proposalDropdownTitle" variant="outline-danger" class="m-md-2" style="margin-left: 0 !important;">
                                                        <span v-if="listProposalTypes.length > 0">
                                                            <b-dropdown-item @click="selectProposalType((listProposalTypes.find(o => o.default_type == 1)))"><span class="proposal-type-name-span deselect-proposal-type-name-span">Deselect Proposal Template</span></b-dropdown-item>
                                                            <span v-for="listProposalType in listProposalTypes" class="proposal-type-head-span" v-if="(listProposalType.default_type !== 1)">
                                                                <b-dropdown-item @click="selectProposalType(listProposalType)"><span class="proposal-type-name-span">{{listProposalType.name}}</span></b-dropdown-item>
                                                                <button type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" @click.prevent=""
                                                                        aria-expanded="false">
                                                                        <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                                                             viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                                                            <path
                                                                                d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                            <path
                                                                                d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                            <path
                                                                                d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                        </svg>
                                                                    </button>
                                                                    <div class="dropdown-menu">
                                                                        <a class="dropdown-item" v-if="listProposalType.default_type !== 1" @click="editProposalTypeEditName(listProposalType)">Rename</a>
                                                                        <a class="dropdown-item" v-else-if="listProposalType.default_type == 1 && role" @click="editProposalTypeEditName(listProposalType)">Rename</a>
                                                                        <a class="dropdown-item" @click="proposalTypeDelete(listProposalType)">Delete</a>
                                                                        <a class="dropdown-item" @click="proposalTypeDuplicate(listProposalType)">Make Copy</a>
                                                                    </div>
                                                            </span>
                                                        </span>
                                                        <span v-else>
                                                            <b-dropdown-item class="dropdownCustomItem">No proposal has been created yet.</b-dropdown-item>
                                                        </span>
                                                    </b-dropdown>
                                                </div>
                                                <div class="flex-1 text-right float-right mt-2">
                                                    <input @click="openProposalTypeModal()" type="button" class="btn btn-primary" value="Add new template" />
                                                </div>
                                                <div v-if="showSectionListing" class="flex-1 text-right float-right mt-2 mr-4">
                                                    <input @click="addSection()" type="button" class="btn btn-primary add-new-section-button" value="Add new section" />
                                                </div>
                                            </div>

                                            <div class="proposal-type-sections-div d-inline-block w-100" v-if="coverSection">
                                                <draggable>
                                                    <transition-group>
                                                        <div :key="coverSection.id"
                                                             class="flex justify-between border-2 p-2 rounded mb-1 text-grey-darker tracking-wide cursor-pointer hover:border-followup-nav border-grey-lighter bg-grey-lighter"
                                                             :id="coverSection.id">
                                                            <div class="flex flex-col mr-15">
                                                                <div class="flex items-baseline">
                                                                    <div class="proposal-type-section-name">Cover Page</div>
                                                                </div>
                                                            </div>

                                                            <div v-if="role" class="dropdown open dropleft">
                                                                <button type="button" @click="openCoverPageSettingModal">
                                                                    <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                                                         viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                        <path
                                                                            d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                        <path
                                                                            d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </transition-group>
                                                </draggable>
                                            </div>
                                            <div v-if="showSectionListing">
                                                <div class="proposal-type-sections-div d-inline-block w-100" v-if="sections.length > 0">
                                                    <draggable v-model="sections" @change="handleSectionOrderChange">
                                                        <transition-group>
                                                            <div v-for="(section, index) in sections" :key="section.id"
                                                                 class="flex justify-between border-2 p-2 rounded mb-1 text-grey-darker tracking-wide cursor-pointer hover:border-followup-nav border-grey-lighter bg-grey-lighter"
                                                                 :class="(!section.include_in_report)? 'section-turned-off-active':''"
                                                                 :id="section.id">
                                                                <div class="flex flex-col mr-15">
                                                                    <div class="flex items-baseline">
                                                                        <div class="proposal-type-section-name" :id="'sectionName'+section.id" :title="section.name">{{ section.name }}</div>
                                                                        <div :id="'sectionRename'+section.id" class="section-rename" style="display: none;"><input type="input" v-model="sectionRenameName" class="section-name-input"> <input type="button" class="btn btn-primary p-1 text-sm ml-4" @click="sectionRenameSave(section)" value="Save"><input type="button" class="btn btn-primary p-1 text-sm ml-2" @click="sectionRenameCancel(section)" value="Cancel"></div>
                                                                    </div>
                                                                </div>

                                                                <div class="dropdown open dropleft">
                                                                    <button type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true"
                                                                            aria-expanded="false">
                                                                        <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                                                             viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                                                            <path
                                                                                d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                            <path
                                                                                d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                            <path
                                                                                d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                                                        </svg>
                                                                    </button>

                                                                    <div class="dropdown-menu">
                                                                        <a class="dropdown-item" @click="renameSection(section)">Rename</a>
                                                                        <a class="dropdown-item" @click="sectionDuplicate(section)">Duplicate</a>
                                                                        <a class="dropdown-item" v-if="section.include_in_report" @click="includeInReport(section, 0)">Turn Off</a>
                                                                        <a class="dropdown-item" v-else @click="includeInReport(section, 1)">Turn On</a>
                                                                        <a class="dropdown-item" v-if="!section.is_text" @click="isText(section, 'text')">Text Page</a>
                                                                        <a class="dropdown-item" v-if="!section.is_pdf" @click="isText(section, 'pdf')">PDF Upload</a>
                                                                        <a class="dropdown-item" v-if="!section.is_sheet" @click="isText(section, 'sheet')">Excel Sheet</a>
                                                                        <a class="dropdown-item" v-if="!section.mark_standard" @click="markSection(section, 1)">Standard Section</a>
                                                                        <a class="dropdown-item" v-else @click="markSection(section, 0)">Remove Standard Section</a>
                                                                        <a class="dropdown-item" @click="deleteSection(section)">Delete</a>
                                                                        <a class="dropdown-item" v-if="!section.proposal_template_group_id" @click="assignTemplateGroupModal(section)">Assign Section Content</a>
                                                                        <a class="dropdown-item" v-if="section.proposal_template_group_id" @click="assignTemplateGroupModal(section)">Change Assigned Section Content</a>
                                                                        <a class="dropdown-item" v-if="section.proposal_template_group_id" @click="unassignTemplateGroupModal(section)">Unassign Section Content</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </transition-group>
                                                    </draggable>
                                                </div>
                                                <div class="proposal-type-sections-div d-inline-block w-100 text-center" v-else>
                                                    No section added yet.
                                                </div>
                                                <div class="block text-center mt-2">
                                                    <input @click="addSection()" type="button" class="btn btn-primary add-new-section-button" value="Add new section" />
                                                </div>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </b-container>
        <div class="container mt-5 ml-3">
            <p class="mb-2">Proposal Generator Button</p>
            <label for="proposalButtonSwitch" class="inline-block">OFF</label>
            <b-form-checkbox @change="proposalButtonSwitchUpdate" name="check-button" v-model="proposalButtonSwitch" id="proposalButtonSwitch" class="inline-block" style="margin-left:10px !important" switch>
            </b-form-checkbox>
            <label for="proposalButtonSwitch" class="inline-block">ON</label>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import draggable from 'vuedraggable';
import Multiselect from "vue-multiselect";
import Swatches from "vue-swatches";
import Form from "../../utils/form";

export default {
    name: "proposal-settings",
    props:['proposalTypes', 'role', 'proposalTemplateGroups', 'team'],
    components: {draggable, Multiselect},
    data() {
        return {
            proposalDropdownTitle: 'Standard Proposal',
            listProposalTypes: this.proposalTypes,
            proposalTypeName: '',
            sections: [],
            showSectionListing: false,
            selectedType:'',
            sectionRenameName:'',
            proposalTypeModalTitle: 'Template Name',
            proposalTypeModalButton: 'Save',
            proposalTypeEdit: null,
            coverSection:null,
            tempCoverSectionSettings:null,
            allProposalTemplateGroups: this.proposalTemplateGroups,
            selectedProposalTemplateGroup: null,
            selectedSectionForTemplateGroup:null,
            proposalButtonSwitch:(this.team.has_proposal_button_access == 1)? true:false
        };
    },
    mounted(){
        this.listProposalTypes.forEach(item => {
            if(item.default_type == 1){
                this.selectProposalType(item);
            }
        });
    },
    methods: {
        openProposalTypeModal(){
            this.proposalTypeModalTitle = 'Template Name';
            this.proposalTypeModalButton = 'Save';
            $('#proposalTypeModal').modal("show");
        },
        saveProposalType(){
            if(this.proposalTypeName.trim() == '' || this.proposalTypeName == null){
                this.fireErrorToast('Please enter template name.');
                this.proposalTypeName = '';
                return false;
            }
            axios.post(route('api.proposal-type.store'), {name:this.proposalTypeName}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.listProposalTypes = data.listProposalTypes;
                    this.listProposalTypes.forEach(item => {
                        if(item.name == this.proposalTypeName){
                            this.selectProposalType(item);
                            this.proposalDropdownTitle = item.name;
                        }
                    });
                    $('#proposalTypeModal').modal("hide");
                    this.proposalTypeName = '';
                    this.coverSection = data.coverPage;
                    this.tempCoverSectionSettings = {
                        allCover:data.coverPage.all_cover ,
                        cover1:data.coverPage.cover_1,
                        cover2:data.coverPage.cover_2,
                        cover3:data.coverPage.cover_3,
                        cover4:data.coverPage.cover_4,
                        cover5:data.coverPage.cover_5
                    };
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        editProposalTypeEditName(proposalType){
            this.proposalTypeName = proposalType.name;
            this.proposalTypeEdit = proposalType;
            this.proposalTypeModalTitle = 'Edit Template Name';
            this.proposalTypeModalButton = 'Update';
            $('#proposalTypeModal').modal("show");
        },
        updateProposalType(){
            if(this.proposalTypeName.trim() == '' || this.proposalTypeName == null){
                this.fireErrorToast('Please enter template name.');
                this.proposalTypeName = '';
                return false;
            }

            if(this.proposalTypeName.trim() == this.proposalTypeEdit.name){
                $('#proposalTypeModal').modal("hide");
                this.proposalTypeModalTitle = 'Template Name';
                this.proposalTypeModalButton = 'Save';
                this.proposalTypeEdit = null;
                this.proposalTypeName = '';
                return false;
            }

            axios.post(route('api.proposal-type.update'), {name:this.proposalTypeName, proposalType:this.proposalTypeEdit}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.listProposalTypes = data.listProposalTypes
                    this.listProposalTypes.forEach(item => {
                        if(item.name == this.proposalTypeName){
                            this.selectProposalType(item);
                            this.proposalDropdownTitle = item.name;
                        }
                    });
                    $('#proposalTypeModal').modal("hide");
                    this.proposalTypeModalTitle = 'Template Name';
                    this.proposalTypeModalButton = 'Save';
                    this.proposalTypeEdit = null;
                    this.proposalTypeName = '';
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        proposalTypeCancel(){
            this.proposalTypeModalTitle = 'Template Name';
            this.proposalTypeModalButton = 'Save';
            this.proposalTypeEdit = null;
            this.proposalTypeName = '';
        },
        proposalTypeDelete(proposalType){
            Swal.fire({
                title             : "Are you sure?",
                text              : "Once deleted, you will not be able to recover this proposal template!",
                icon              : "warning",
                buttons           : true,
                showCancelButton  : true,
                confirmButtonColor: 'red',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then(result => {
                if (result.value) {
                    axios.post(route('api.proposal-type.delete'), {proposalType: proposalType}).then((data) => {
                        if(data.data.status == 'success'){
                            this.fireSuccessToast(data.data.message);
                            window.open(route('settings.team', {tab: 'proposal-settings',team:this.team.id}),'_self');
                        }else{
                            this.fireErrorToast(data.message);
                        }
                    });
                }
            });
        },
        handleSectionOrderChange(event){
            if (event.moved) {
                let oldIndex = event.moved.oldIndex;
                let newIndex = event.moved.newIndex;
                this.sections[newIndex].order = newIndex;
                if (newIndex < oldIndex) {
                    for (let i = newIndex + 1; i <= oldIndex; i++) {
                        this.sections[i].order++;
                    }
                } else {
                    for (let i = oldIndex; i < newIndex; i++) {
                        this.sections[i].order--;
                    }
                }

                let moveForm = new Form({
                    sections: this.sections,
                    proposal_type_id:this.selectedType.id
                });

                moveForm.post(route('api.proposal-type-section.moved'))
                    .then((data) => {
                        if (data.status === 'success') {
                            this.sections = data.proposalTypeSections;
                            this.fireSuccessToast(data.message);
                        } else {
                            this.fireErrorToast(response.message);
                        }
                    });
            }
        },
        addSection(){
            $('.add-new-section-button').attr('disabled',true);
            var customSectionNumber = [];
            var customSectionSplit = [];
            var sectionName = '';
            this.sections.forEach(item => {
                if(item.name.match(/Custom Section/gi)){
                    customSectionSplit = item.name.split(' ');
                    customSectionNumber.push(parseInt(customSectionSplit[2]));
                }
            });
            if(customSectionNumber.length > 0){
                var largest = Math.max.apply(0, customSectionNumber);
                sectionName  = 'Custom Section ' + (largest + 1);
            }else{
                sectionName  = 'Custom Section 1';
            }

            axios.post(route('api.proposal-type-section.store'), {name:sectionName, proposal_type_id:this.selectedType.id}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.sections = data.proposalTypeSections;
                    $('.add-new-section-button').attr('disabled',false);
                }else{
                    this.fireErrorToast(data.message);
                    $('.add-new-section-button').attr('disabled',false);
                }
            });
        },
        selectProposalType(proposalType){
            axios.get(route('api.proposal-type-sections.list', {'id':proposalType.id})).then(({data}) => {
                this.sections = data.proposalTypeSections;
                this.showSectionListing = true;
                this.proposalDropdownTitle = proposalType.name;
                this.selectedType = proposalType;
                this.coverSection = data.proposalTypeCoverPage;
                this.tempCoverSectionSettings = {
                    allCover:data.proposalTypeCoverPage.all_cover ,
                    cover1:data.proposalTypeCoverPage.cover_1,
                    cover2:data.proposalTypeCoverPage.cover_2,
                    cover3:data.proposalTypeCoverPage.cover_3,
                    cover4:data.proposalTypeCoverPage.cover_4,
                    cover5:data.proposalTypeCoverPage.cover_5
                };
            });
        },
        deleteSection(section){
            axios.post(route('api.proposal-type-section.delete'), {section:section}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.sections = data.proposalTypeSections;
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        markSection(section, mark){
            axios.post(route('api.proposal-type-section.mark'), {section:section, mark:mark}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.sections = data.proposalTypeSections;
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        isText(section, type){
            axios.post(route('api.proposal-type-section.type'), {section:section, type:type}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.sections = data.proposalTypeSections;
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        includeInReport(section, inReport){
            axios.post(route('api.proposal-type-section.report'), {section:section, inReport:inReport}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.sections = data.proposalTypeSections;
                    if(inReport == 0){
                        $('#'+section.id).addClass('section-turned-off-active')
                    }else{
                        $('#'+section.id).removeClass('section-turned-off-active')
                    }
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        sectionDuplicate(section){
            axios.post(route('api.proposal-type-section.duplicate'), {section:section}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.sections = data.proposalTypeSections;
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        renameSection(section){
            this.sectionRenameName = section.name;
            $('#sectionName'+section.id).hide();
            $('#sectionRename'+section.id).show();
        },
        sectionRenameSave(section){
            if(this.sectionRenameName.trim() == '' || this.sectionRenameName == null){
                this.fireErrorToast('Please enter section name.');
                return false;
            }

            if(this.sectionRenameName.trim() == section.name){
                $('#sectionName'+section.id).show();
                $('#sectionRename'+section.id).hide();
                this.sectionRenameName = '';
            }

            axios.post(route('api.proposal-type-section.rename'), {section:section, newName: this.sectionRenameName}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.sections = data.proposalTypeSections;
                    $('#sectionName'+section.id).show();
                    $('#sectionRename'+section.id).hide();
                    this.sectionRenameName = '';
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        sectionRenameCancel(section){
            $('#sectionName'+section.id).show();
            $('#sectionRename'+section.id).hide();
            this.sectionRenameName = '';
        },
        openCoverPageSettingModal(){
            $('#CoverPageSettingModal').modal('show');
        },
        saveCoverPageSettings(){
            var dataToUpdate = {
                cover: this.tempCoverSectionSettings,
                proposalTypeId: this.selectedType.id
            };
            axios.post(route('api.proposal-type-cover-page.update'), dataToUpdate).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.tempCoverSectionSettings = {
                        allCover:data.coverPage.all_cover ,
                        cover1:data.coverPage.cover_1,
                        cover2:data.coverPage.cover_2,
                        cover3:data.coverPage.cover_3,
                        cover4:data.coverPage.cover_4,
                        cover5:data.coverPage.cover_5
                    };
                    $('#CoverPageSettingModal').modal('hide');
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        cancelCoverPageSettings(){
            $('#CoverPageSettingModal').modal('hide');
            axios.get(route('api.proposal-type-sections.list', {'id':this.selectedType.id})).then(({data}) => {
                this.tempCoverSectionSettings = {
                    allCover:data.proposalTypeCoverPage.all_cover ,
                    cover1:data.proposalTypeCoverPage.cover_1,
                    cover2:data.proposalTypeCoverPage.cover_2,
                    cover3:data.proposalTypeCoverPage.cover_3,
                    cover4:data.proposalTypeCoverPage.cover_4,
                    cover5:data.proposalTypeCoverPage.cover_5
                };
            });
        },
        turnOffCover(){
            this.$nextTick(() => {
                if(this.tempCoverSectionSettings.allCover == 1){
                    this.tempCoverSectionSettings.cover1 = 0;
                    this.tempCoverSectionSettings.cover2 = 0;
                    this.tempCoverSectionSettings.cover3 = 0;
                    this.tempCoverSectionSettings.cover4 = 0;
                    this.tempCoverSectionSettings.cover5 = 0;
                }else{
                    this.tempCoverSectionSettings.cover1 = 1;
                    this.tempCoverSectionSettings.cover2 = 1;
                    this.tempCoverSectionSettings.cover3 = 1;
                    this.tempCoverSectionSettings.cover4 = 1;
                    this.tempCoverSectionSettings.cover5 = 1;
                }
            });

        },
        turnOnOtherSections(){

            this.$nextTick(() => {
                if (this.tempCoverSectionSettings.allCover == 1) {
                    this.tempCoverSectionSettings.allCover = 0;
                }

                if (this.tempCoverSectionSettings.cover1 == 0 && this.tempCoverSectionSettings.cover2 == 0 && this.tempCoverSectionSettings.cover3 == 0 && this.tempCoverSectionSettings.cover4 == 0 && this.tempCoverSectionSettings.cover5 == 0) {
                    this.tempCoverSectionSettings.allCover = 1;
                }
            });
        },
        fireSuccessToast(message) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            Toast.fire({
                type : 'success',
                title: message,
            });
        },
        fireErrorToast(message) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            Toast.fire({
                type : 'error',
                title: message,
            });
        },
        proposalTypeDuplicate(proposalType){
            axios.post(route('api.proposal-type.duplicate'), {proposalType:proposalType}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.listProposalTypes = data.listProposalTypes
                    this.listProposalTypes.forEach(item => {
                        if(item.id == data.createdProposalType.id){
                            this.selectProposalType(item);
                            this.proposalDropdownTitle = item.name;
                        }
                    });
                    $('#proposalTypeModal').modal("hide");
                    this.proposalTypeModalTitle = 'Template Name';
                    this.proposalTypeModalButton = 'Save';
                    this.proposalTypeEdit = null;
                    this.proposalTypeName = '';
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        assignTemplateGroupModal(section){
            this.getAllTemplateGroups();
            this.selectedSectionForTemplateGroup = section;
            if(this.allProposalTemplateGroups.length > 0){
                this.allProposalTemplateGroups.forEach(item => {
                    if(section.proposal_template_group_id == item.id){
                        this.selectedProposalTemplateGroup = item;
                    }
                });
            }
            $('#assignTemplateGroup').modal("show");
        },
        cancelAssignProposalTemplateGroup(){
            this.selectedSectionForTemplateGroup = null;
            this.selectedProposalTemplateGroup = null;
            $('#assignTemplateGroup').modal("hide");
        },
        assignTemplateGroup(){
            axios.post(route('api.proposal-type.assign-template-group'), {section:this.selectedSectionForTemplateGroup, template: this.selectedProposalTemplateGroup}).then(({data}) => {
                if(data.status == 'success'){
                    this.fireSuccessToast(data.message);
                    this.listProposalTypes = data.listProposalTypes
                    this.listProposalTypes.forEach(item => {
                        if(item.id == data.createdProposalType.id){
                            this.selectProposalType(item);
                            this.proposalDropdownTitle = item.name;
                        }
                    });
                    this.selectedSectionForTemplateGroup = null;
                    this.selectedProposalTemplateGroup = null;
                    $('#assignTemplateGroup').modal("hide");
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        getAllTemplateGroups(){
            axios.post(route('api.proposal-type.all-template-group')).then(({data}) => {
                if(data.status == 'success'){
                    if(data.listTemplateGroup.length > 0){
                        this.allProposalTemplateGroups = data.listTemplateGroup;
                    }else{
                        this.allProposalTemplateGroups = [];
                    }
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        },
        proposalButtonSwitchUpdate(){
            this.$nextTick(()=>{

                var data = {
                    'access': (this.proposalButtonSwitch)? 1:0
                };

                axios.post('/settings/update-has-proposal-button-access', data).then(
                    (response) => {
                        Bus.$emit('updateTeam');
                        Bus.$emit('updateTeams');
                        this.fireSuccessToast(response.data.message);
                    }
                );
            });
        },
        unassignTemplateGroupModal(section){
            axios.post(route('api.proposal-type.unassign-template-group'), {section:section}).then(({data}) => {
                if(data.status == 'success'){
                    this.selectProposalType(this.selectedType);
                    this.fireSuccessToast(data.message);
                }else{
                    this.fireErrorToast(data.message);
                }
            });
        }
    }
};
</script>

<style>
#proposal-type-setting{
    max-width: 100% !important;
}

#proposal-type-setting button{
    color: #01b1af !important;
    border-color: #01b1af !important;
}

#proposal-type-setting button:hover,
#proposal-type-setting button.dropdown-toggle,
#proposal-type-setting button.active,
.show > .btn-outline-danger.dropdown-toggle{
    color: #fff !important;
    background-color: #01b1af !important;
    border-color: #01b1af !important;
}

.proposal-type-section-name{
    color:#01b1af;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 350px;
    display: inline-block;
}

.section-turned-off-active {
    border-color: red !important;
    background-color: #e6e6e6;
}

.section-name-input {
    padding: 3px 10px;
    border-radius: 5px;
    width: 70%;
}

.section-rename{
    width: 750px;
}

#proposal-type-setting ul.dropdown-menu.show {
    width: 500px;
}

.proposal-type-delete {
    float: right;
    padding-top: 8px;
    color: red;
}

.proposal-type-edit{
    float: right;
    padding-top: 8px;
    color: #01b1af;
    margin-right: 20px;
}

.proposal-type-name-span{
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    padding-top: 5px;
}

.coverCheckboxDiv{
    width: 50%;
    display: inline-block;
}

button#proposal-type-setting__BV_toggle_ {
    width: 250px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
}

span.proposal-type-head-span {
    display: block;
    overflow: hidden;
}

span.proposal-type-head-span li {
    width: 90%;
    float: left;
}

span.proposal-type-head-span button {
    width: 10%;
    padding: 10px;
}

span.proposal-type-head-span button:focus {
    border:none !important;
}
</style>
